import { z } from 'zod';
import { optionalPhoneNumberSchema } from './phoneNumber.js';
export const PARTNER_COCKPIT_MIN_PASSWORD_LENGTH = 8;
export const PARTNER_COCKPIT_MAX_NAME_LENGTH = 100;
const emailField = z.email();
const newPasswordField = z.string().min(PARTNER_COCKPIT_MIN_PASSWORD_LENGTH);
const nameField = z.string().trim().max(PARTNER_COCKPIT_MAX_NAME_LENGTH);
export const partnerCockpitNameFieldSchema = nameField.optional();
export const partnerCockpitRequiredNameFieldSchema = nameField.min(1);
export const loginPartnerCockpitUserSchema = z.object({
    email: emailField,
    password: z.string().min(1),
});
export const requestPartnerCockpitPasswordResetSchema = z.object({ email: emailField });
export const setPartnerCockpitPasswordSchema = z.object({ password: newPasswordField });
export const changePartnerCockpitPasswordSchema = z.object({
    oldPassword: z.string().min(1),
    newPassword: newPasswordField,
});
export const requestPartnerCockpitMagicLinkSchema = z.object({ email: emailField });
export const requestPartnerCockpitEmailChangeSchema = z.object({
    currentPassword: z.string().min(1),
    newEmail: emailField,
});
export const updatePartnerCockpitProfileSchema = z.object({
    firstName: partnerCockpitNameFieldSchema,
    lastName: partnerCockpitNameFieldSchema,
    phoneNumber: optionalPhoneNumberSchema,
    smsNotificationsEnabled: z.boolean().optional(),
});
// Locales the partner cockpit is available in; mirrors the backend LanguageKey union.
export const partnerCockpitLanguageSchema = z.enum(['de-CH', 'en-CH', 'fr-CH', 'it-CH']);
export const updatePartnerCockpitLanguageSchema = z.object({ language: partnerCockpitLanguageSchema });
export const partnerCockpitCsrfResponseSchema = z.object({
    csrfToken: z.string().min(1),
});
